var ControlsModule = /** @class */ (function () {
    function ControlsModule() {
    }
    return ControlsModule;
}());
export { ControlsModule };
